
// @mui
import { styled } from '@mui/material/styles';
// components
import Page from '../components/Page';
 import { HomeHeader, Choose, Agent, Plan, HomeAdvertisement } from '../sections/home';

 import { APP_NAME } from '../config';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(() => ({
  height: '100%',
}));
const ContentStyle = styled('div')(({ theme }) => ({
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: theme.palette.background.default,
  }));

// ----------------------------------------------------------------------

export default function HomePage() {
  return (
    <Page title={` ${APP_NAME} Is a technology platform that offers solutions to digital needs at best possible price without compromising quality. data, airtime, electricity, cable, airtime to cash, all available for you`} sx={{ height: 1 }}>
      <RootStyle>
        <HomeHeader />
      <ContentStyle>
      <Choose />
      <Agent />
      <Plan />
      <HomeAdvertisement />
      </ContentStyle>
      </RootStyle>
    </Page>
  );
}
